export default __webpack_public_path__ + "static/common-app-logo-black-new-0bb016a61c1dc3b8e95467420eb3abe0.svg";